<template>
  <sme-card class="h-100" v-pdf-chart-group>
    <h6 class="mb-3 ddc-title">{{ title }}</h6>
    <div class="d-flex justify-content-center">
      <div class="ddc-chart">
        <pdf-chart :title="title" layout="triple">
          <donut-chart
            :labels="labels"
            :values="values"
            :colors="colors"
            :show-data-labels="false"
            cutout="0%"
            :chart-options="{
              aspectRatio: 1,
              plugins: { tooltip: { enabled: true }, legend: { display: false } },
            }"
          />
        </pdf-chart>
      </div>
    </div>

    <div class="ddc-legend mt-3" :class="{ 'ddc-legend--compact': compact }">
      <div v-for="(label, index) in labels" :key="label" class="ddc-legend__item">
        <span class="ddc-legend__dot" :style="{ backgroundColor: colors[index] }" />
        <span class="ddc-legend__label">{{ label }}</span>
        <span class="ddc-legend__value">{{ formatValue(values[index]) }}</span>
      </div>
    </div>
  </sme-card>
</template>

<script setup>
import PdfChart from '@/components/PdfChart.vue';
import SmeCard from '@/components/atoms/SmeCard.vue';
import DonutChart from '@/components/charts/DonutChart.vue';

const props = defineProps({
  title: { type: String, required: true },
  labels: { type: Array, required: true },
  values: { type: Array, required: true },
  colors: { type: Array, required: true },
  valueSuffix: { type: String, default: '' },
  compact: { type: Boolean, default: true },
});

const formatValue = value => `${value}${props.valueSuffix}`;
</script>

<style scoped lang="scss">
.ddc-title {
  font-weight: 700;
}

.ddc-chart {
  width: 220px;
  max-width: 100%;
}

.ddc-legend {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;

  &__item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__label {
    flex: 1;
    font-size: 13px;
    color: var(--palette-color-default);
  }

  &__value {
    font-size: 13px;
    font-weight: 600;
    color: var(--palette-color-default);
  }

  &--compact {
    gap: 0.375rem;
  }

  &--compact &__label,
  &--compact &__value {
    font-size: 11px;
  }

  &--compact &__dot {
    width: 8px;
    height: 8px;
  }
}
</style>
